import {IntFieldBox} from "./int-field-box";
import styled from "styled-components";

export const IntFieldLabeledBox = ({children, label, placeholder, isActive, titleTooltip, ...props}) => {
  return <IntFieldBox {...props}>
    <LabeledWrap >
      <LabelElement isActive={isActive}>
        {isActive ? (label || placeholder) : (placeholder || label)}
      </LabelElement>
      <div style={{ position: "absolute", right: "2.8rem", display: "flex", height: '100%', alignItems: 'center', top: '14px', justifyContent: 'flex-start', flexDirection: 'column'}}>
        {titleTooltip}
      </div>
      {children}
    </LabeledWrap>
  </IntFieldBox>
}

const LabeledWrap = styled.div`
  transition: all .2s ease;
  position: relative;
  padding: 1.5rem 1rem 0.5rem;
`;

const LabelElement = styled.div`
  position: absolute;
  top: .4rem;
  display: flex;
  align-items: center;
  gap: .5rem;
  
  transform: translateY(-1rem);
  left: 1rem;
  transition: 0.3s ease;
  pointer-events: none;
  font-size: .9rem;
  color: inherit;
  font-family: inherit;
  transform-origin: 0 50%;
  transform: ${props => props.isActive ? 'scale(0.9)' : 'scale(1)'};
  top: ${props => props.isActive ? '.4rem' : '1.1rem'};
`;